/**
 * Owner feedback form and popups
 */

const delegate = require('emmy/delegate');
const q = require('queried');
const dialog = require('dialog-component');
const css = require('mucss/css');
const scrollbarWidth = require('mucss/scrollbar');
const on = require('emmy/on');
const emit = require('emmy/emit');
const ajax = require('component-ajax');
const cookie = require('cookie-cutter');
const forEach = require('object-foreach');
const _ = require('./i18n');

const form = q('.owner-form');

// FIXME: use phones exported to the kudago object
const PHONE_NUMBERS = {
  spb: '+7 (812) 339-45-25',
  msk: '+7 (499) 753-45-25',
  krasnoyarsk: '+7 (983) 599-35-24',
};

// show dialog on click on popup
delegate(document.body, 'click', '[data-popup]', (e) => {
  const item = e.delegateTarget;
  const contentSel = item.getAttribute('data-popup-content');
  const content = q(contentSel);

  content.removeAttribute('hidden');

  // create and show the dialog
  const dialogItem = dialog(null, content)
    .effect('fade')
    .overlay()
    .fixed()
    .closable()
    .escapable()
    .on('show', () => {
      css(document.body, {
        overflow: 'hidden',
        'margin-right': scrollbarWidth,
      });
    })
    .on('close', closeDialog)
    .on('hide', closeDialog);

  // manage dialog class
  if (!form.hasAttribute('hidden')) dialogItem.addClass('dialog-big');

  // show the dialog
  dialogItem.show();

  // bind events
  function closeDialog() {
    content.setAttribute('hidden', true);
    css(document.body, {
      overflow: null,
      'margin-right': null,
    });
    document.body.appendChild(content);
  }

  on(dialogItem.el, 'click', (evt) => {
    if (content.contains(evt.target)) return;
    closeDialog();
    dialogItem.hide();
  });

  // hide on click on reset
  on(q('[type="reset"]', dialogItem.el), 'click', () => {
    closeDialog();
    dialogItem.hide();
  });
});

// submit form
on(form, 'submit', submitForm);

function submitForm(e) {
  e.preventDefault();

  if (!isFull(form)) return;

  const data = {
    content_type: form.content_type.value,
    object_id: form.object_id.value,
    phone_number: form.phone_number.value,
    name: `${form.name.value}, ${form.position.value}`,
    email: form.email.value,
    message:
      (form.site ? _('Site: %s\n\n', [form.site.value]) : '')
      + form.message.value,
    'g-recaptcha-response': form['g-recaptcha-response'].value,
  };

  q('.overlay-submit', form).setAttribute('disabled', true);

  ajax({
    type: 'POST',
    url: form.action,
    data,
    headers: {
      'X-CSRFToken': cookie.get('csrftoken'),
    },
    success() {
      emit(form, 'success', true, true);

      // console.log('succesfully sent', e)
      clearErrors(form);
      clearFields(form);
      form.setAttribute('hidden', true);

      q('.owner-title', form.parentNode).innerHTML = _(
        'Thank you for your request. We will contact you soon.',
      );
      q('.owner-text', form.parentNode).setAttribute('hidden', true);
      emit(form, 'updateSize', true, true);

      // hide overlay
      // dialogItem.hide(3000);
    },
    error() {
      renderErrors(form, e.responseJSON);

      q('.overlay-submit', form).removeAttribute('disabled');
    },
  });
}

// create texts for the popup
createTexts();

/** check whether form data is full, render errors */
function isFull(formObj) {
  const errObj = {};

  if (!formObj.name.value) errObj.name = [_('What is your name?')];
  if (!formObj.position.value) errObj.position = [_('What is your position?')];
  if (!formObj.phone_number.value) errObj.phone_number = [_('Can we call you, please?')];
  if (!formObj.email.value) errObj.email = [_('Can we contact you via email?')];
  if (!formObj.message.value) errObj.message = [_('Please specify purpose of your request.')];
  if (!formObj.classList.contains('debugMode')) {
    if (!formObj['g-recaptcha-response'].value) errObj.captcha = [_('This field is required')];
  }

  if (Object.keys(errObj).length > 0) {
    renderErrors(formObj, errObj);
    return false;
  }

  return true;
}

/** Form handlers */
function renderErrors(formObj, errObj) {
  let target;

  clearErrors(formObj);

  forEach(errObj, (value, errFieldName) => {
    target = document.getElementById(`owner-${errFieldName}-error`);
    target.innerHTML = errObj[errFieldName].join('\n');
  });

  emit(formObj, 'updateSize', true, true);
}

function clearErrors(formObj) {
  const errors = q.all('.owner-error', formObj);
  errors.forEach((error) => {
    error.innerHTML = '';
  });
  emit(form, 'updateSize', true, true);
}

function clearFields(formObj) {
  const fields = q.all('.owner-input, textarea', formObj);
  fields.forEach((field) => {
    field.value = '';
  });
  emit(formObj, 'updateSize', true, true);
}

/** Create texts for the popup */
function createTexts() {
  const org = q('.overlay-text-organizer');
  const owner = q('.overlay-text-owner');
  const ownerText = q('.owner-text');

  if (!ownerText) return;

  const visits = ownerText.getAttribute('data-visits');
  const visitsFormat = _.ngettext(
    'At the moment the page has %s view',
    'At the moment the page has %s views',
    +visits,
  );
  const title = _('Become our client and you will be able to:');

  if (org) {
    const abilities = [
      _('increase number of views'),
      _('update event details'),
      _('keep discussion with audience'),
      _('inform visitors about changes'),
      _('add a registration form and get the list of registered users'),
      _('sell tickets through partners or your own interface'),
    ];

    org.innerHTML = `
      <p>${_.interpolate(visitsFormat, [+visits])}.</p>
      <p>${title}</p>
      <ol>
        ${abilities.map((a) => `<li>${a}</li>`).join('')}
      </ol>
    `;
  }

  if (owner) {
    const abilities = [
      _('increase number of views'),
      _('promptly update place details'),
      _('keep discussion with audience'),
      _('inform visitors about upcoming events and offers'),
    ];

    owner.innerHTML = `
      <p>${_.interpolate(visitsFormat, [+visits])}.</p>
      <p>${title}</p>
      <ol>
        ${abilities.map((a) => `<li>${a}</li>`).join('')}
      </ol>
    `;
  }

  const text = org || owner;

  if (text) {
    const phoneLocationSlug = getPhoneLocationSlug();
    const phoneLocation = kudago.locations[phoneLocationSlug].P;
    const callUsText = _.interpolate(_('Call us in %s:'), [phoneLocation]);
    const sendRequestText = _('or send us the request:');

    text.innerHTML += `
      <p>${callUsText}</p>
      <p>${PHONE_NUMBERS[phoneLocationSlug]}</p>
      <p>${sendRequestText}</p>
    `;
  }
}

function getPhoneLocationSlug() {
  const { location } = kudago;

  switch (location) {
    case 'spb':
    case 'krasnoyarsk':
      return location;
    default:
      return 'msk';
  }
}
